<template>
  <div class="row-span-1 w-full flex-col bg-blue-10">
    <div
        class="grid grid-flow-row-dense md:grid-flow-col md:grid-rows-1 lg:grid-flow-row-dense"
    >
      <template v-if="userType === 'emp'">
        <AgencyAdvertContactOptionsEmployer
            :agency="agency"
            @contactFormSelect="(event) => $emit('contactFormSelect', event)"
        />
      </template>

      <template v-else-if="userType === 'cnd'">
        <AgencyAdvertContactOptionsCandidate
            :agency="agency"
            @contactFormSelect="(event) => $emit('contactFormSelect', event)"
            @moreInfoSelect="(event) => $emit('moreInfoSelect')"
        />
      </template>

      <template v-else>
        <AgencyAdvertContactOptionsNeither
            :agency="agency"
            @contactFormSelect="(event) => $emit('contactFormSelect', event)"
            @moreInfoSelect="(event) => $emit('moreInfoSelect')"
        />
      </template>
    </div>
  </div>
</template>
<script>
import AgencyAdvertContactOptionsCandidate from 'Components/AgencyAdvertContactOptionsCandidate.vue';
import AgencyAdvertContactOptionsEmployer from 'Components/AgencyAdvertContactOptionsEmployer.vue';
import AgencyAdvertContactOptionsNeither from 'Components/AgencyAdvertContactOptionsNeither.vue';
import {mapGetters, mapState} from "vuex";

export default {
  name: 'AgencyAdvertContactOptions',
  components: {
    AgencyAdvertContactOptionsCandidate,
    AgencyAdvertContactOptionsEmployer,
    AgencyAdvertContactOptionsNeither,
  },
  props: {
    agency: {
      type: Object,
      default: function () {
        return {};
      },
    },
    userType: {
      type: String,
      validator (value) {
        return ['emp', 'cnd', 'neither'].includes(value);
      },
      default: 'neither',
    },
    personalPageUrl: {
      type: String,
    },
  },
};
</script>
